import FJAIAudioRight from '../view/FJAIAudioRight.jsx';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useSelector, useDispatch } from 'react-redux';
import FJActionAIAudioGenerator from '../../../../redux/action/FJActionAIAudioGenerator.js';

const FJAIAudioRightContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const historyList = useSelector(state => state.common.historyList);
    const historyListLoadStatus = useSelector(state => state.common.historyListLoadStatus);
    const presetList = useSelector(state => state.AIAudioGenerator.presetList);

    const onRetry = () => {
        dispatch(FJActionAIAudioGenerator.updateHistoryListAction());
    };

    const onUsePresetInfo = info => {
        dispatch(FJActionAIAudioGenerator.onUsePresetInfoAction(info));
    };

    return (
        <FJAIAudioRight
            historyList={historyList}
            historyListLoadStatus={historyListLoadStatus}
            onRetry={onRetry}
            presetList={presetList}
            onUsePresetInfo={onUsePresetInfo}
        />
    );
};
export default FJAIAudioRightContainer;
